module.exports = __webpack_public_path__ + "static/img/sheji.e67d2754.png";